@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.socialLoginButtons {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 16px;
}

.socialLoginIcon {
  width: 18px;
  height: 18px;
}

.socialLoginButton {
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 8px;
  align-items: center;
  height: 48px;
  padding: 6px;
  border-radius: 8px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-dark-color;
  @include t.text(16px, 26px, "semi-bold");
  color: v.$white-color;
}

/* Chinese Brothers */

.socialLoginButtonChineseBrothers {
background: v.$chinese-brothers-input-bg;
}